import {
  type SearchScope,
  serializeSearchScope,
} from "@/features/search/searchScope";

export function getPublicSearchPath(query: string, scope: SearchScope): string {
  const search = new URLSearchParams({ q: query });
  const serializedScope = serializeSearchScope(scope);
  if (serializedScope) search.set("scope", serializedScope);
  return `/search?${search.toString()}`;
}
